
const mutation = {
  addInfo(state, payload ){
    if(payload) {
      state.downloadInfo.push(payload)
    }
  },
  clearInfo(state){
    state.downloadInfo = [];
  },
  updateInfo(state, payload ){
    if(payload) {
      const targetFileInfo = state.downloadInfo.find(info => info.downloadUrl === payload.downloadUrl);
      if(targetFileInfo){
        targetFileInfo.progress = payload.progress;
      }
    }

  },
}
export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/batchDownload/mutation.js